import firebase from 'firebase/app';
import 'firebase/messaging';
import config from './config';

let fmessaging;
if (config.firebase.status) {
  firebase.initializeApp(config.firebase.config);
  fmessaging = firebase.messaging();
  fmessaging.usePublicVapidKey(config.firebase.messaging.publicKey);
} else {
  console.log('Firebase offline');
}

export const messaging = fmessaging;
